import { render, staticRenderFns } from "./inverted_hammer.vue?vue&type=template&id=2c8f469c"
import script from "./inverted_hammer.vue?vue&type=script&lang=js"
export * from "./inverted_hammer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports